export function getTitle ({title}, locale) {
  return title?.[locale] ?? title;
}
